import { render, staticRenderFns } from "./MultiSelectTruckTag.vue?vue&type=template&id=a120f4d4&"
import script from "./MultiSelectTruckTag.vue?vue&type=script&lang=js&"
export * from "./MultiSelectTruckTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports